export interface GitLogEntry {
  hash: string;
  date: string; // YYYY-MM-DD
  type: string; // feat, fix, refactor, docs, etc.
  message: string; // full conventional commit subject
}

export const gitLog: GitLogEntry[] = typeof __GIT_LOG__ !== 'undefined' ? __GIT_LOG__ : [];
